import getVehicleFilterDescription from "@modules/vehicle/helpers/getVehicleFilterDescription";
import {
  FilterKeys,
  VehicleFilter,
} from "@modules/vehicle/types/vehicleFilter";
import { useEffect, useState } from "react";

const concatFilters = (filters: string[]): string => {
  const sortedFilters = filters.sort();
  const pluralizeFilters = sortedFilters.map((filter) => {
    if (filter?.endsWith("s")) return filter;
    return `${filter}s`;
  });
  const lastFilter = pluralizeFilters.pop();

  return `${pluralizeFilters.join(", ")} ${
    pluralizeFilters.length > 0 ? "and" : ""
  } ${lastFilter}`.trim();
};

function useSeoVehicleFilters(vehicleFilters: VehicleFilter[], locale: string) {
  const [seoInfoWithFilters, setSeoInfoWithFilters] = useState<
    string | undefined
  >();
  useEffect(() => {
    const seoString: string[] = [];
    if (vehicleFilters && vehicleFilters.length > 0) {
      vehicleFilters.forEach((element) => {
        switch (element.key) {
          case FilterKeys.Make:
          case FilterKeys.Model:
          case FilterKeys.BodyStyle:
            seoString.push(
              getVehicleFilterDescription(
                element,
                locale || "",
                true /** modelOnly */
              )
            );
            break;
          default:
        }
      });

      if (seoString && seoString.length > 0) {
        setSeoInfoWithFilters(concatFilters(seoString));
      } else {
        setSeoInfoWithFilters(undefined);
      }
    } else {
      setSeoInfoWithFilters(undefined);
    }
  }, [vehicleFilters, locale]);

  return seoInfoWithFilters;
}

export default useSeoVehicleFilters;
